import React from "react";

import { faSparkles } from "@fortawesome/pro-solid-svg-icons";

import { ButtonStandard } from "@performyard/py-components";

type PostMeetingAnalysisButtonProps = {
	onClick: () => void;
};

const PostMeetingAnalysisButton = ({ onClick }: PostMeetingAnalysisButtonProps): React.ReactElement => {
	return (
		<div className="flex-shrink-0">
			<ButtonStandard
				variant="solid"
				color="primary"
				size="medium"
				iconRight={faSparkles}
				onClick={onClick}
				dangerouslySetClassName="w-auto"
			>
				Post-Meeting Analysis
			</ButtonStandard>
		</div>
	);
};

export default PostMeetingAnalysisButton;
